import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "./utils";

const spinnerVariants = cva(
  "animate-spin rounded-full border-2 border-solid border-current border-r-transparent",
  {
    variants: {
      size: {
        sm: "h-4 w-4 border-2",
        md: "h-5 w-5 border-2",
        lg: "h-6 w-6 border-[3px]",
      },
      variant: {
        primary: "text-mebi-yellow-500",   // MEBI primary color
        white: "text-white",               // White spinner
        neutral: "text-neutral-600",       // Neutral gray spinner
        inherit: "text-current",           // Inherit from parent
      },
    },
    defaultVariants: {
      size: "md",
      variant: "inherit",
    },
  },
);

export interface SpinnerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof spinnerVariants> {}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size, variant, ...props }, ref) => {
    return (
      <div
        className={cn(spinnerVariants({ size, variant, className }))}
        ref={ref}
        role="status"
        aria-label="Loading"
        {...props}
      />
    );
  },
);
Spinner.displayName = "Spinner";

export default Spinner;
export { Spinner };
